import { dateShort } from "@/lib/format";
import { CheckCircle, CircleNotch, Circle } from "@phosphor-icons/react";

const META = {
  done: { icon: CheckCircle, cls: "text-[hsl(var(--success))]", chip: "Done", chipCls: "border-[hsl(var(--success))]/40 bg-[hsl(var(--success))]/10 text-[hsl(var(--success))]" },
  in_progress: { icon: CircleNotch, cls: "text-[hsl(var(--warning))]", chip: "In progress", chipCls: "border-[hsl(var(--warning))]/40 bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]" },
  not_done: { icon: Circle, cls: "text-muted-foreground", chip: "To do", chipCls: "border-border bg-muted text-muted-foreground" },
};

export function OnboardingChecklist({ steps, onAction }) {
  if (!steps || steps.length === 0) return null;
  return (
    <div data-testid="onboarding-checklist" className="rounded-sm border border-border bg-card p-4">
      <div className="overline mb-3">Setup Progress</div>
      <div className="space-y-1">
        {steps.map((s, i) => {
          const m = META[s.status] || META.not_done;
          const Icon = m.icon;
          return (
            <div key={s.key} data-testid={`checklist-${s.key}`} className="flex items-center gap-3 rounded-sm px-2 py-2 hover:bg-accent transition-colors duration-200">
              <span className="font-mono text-xs text-muted-foreground">{i + 1}</span>
              <Icon size={18} weight={s.status === "done" ? "fill" : "regular"} className={m.cls} />
              <div className="flex-1">
                <div className="text-sm font-medium">{s.label}</div>
                {s.date && <div className="font-mono text-[11px] text-muted-foreground">{dateShort(s.date)}</div>}
              </div>
              {s.status !== "done" && s.action && onAction && (
                <button data-testid={`checklist-action-${s.key}`} onClick={() => onAction(s.action)} className="text-xs text-primary hover:underline">
                  {s.action === "connect" ? "Set up" : s.action === "sign" ? "Sign" : s.action === "w9" ? "Add W-9" : "Open"}
                </button>
              )}
              <span className={`inline-flex items-center rounded-sm border px-2 py-0.5 font-mono text-[11px] ${m.chipCls}`}>{m.chip}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
